gsap.registerPlugin(ScrollToPlugin);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach(summary => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', event => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open')
    );
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

// Smooth scroll to anchor
const header = document.querySelector('.section--header');
const stickyHeader = document.querySelector('sticky-header');
const EXCLUDED_ANCHOR_LINKS = ['#recover', '#login', '#ProductInfo'];
const initAnchor = anchor => {
  if (anchor.dataset.initialized) return;

  // TODO: Disable header reveal during scroll
  if (!/^#\D/.test(anchor.hash) || EXCLUDED_ANCHOR_LINKS.includes(anchor.hash.split('-')[0])) return;

  anchor.addEventListener('click', function (e) {
    if (anchor.hash === '#my-account' || anchor.hash === '#my-favorites') return;

    e.preventDefault();

    // Calculate scroll duration based on distance to target
    const anchorEl = document.querySelector(anchor.hash);
    // TODO: Test on nested elements (try parent climbing offsetTop or bounding client rect)
    const shift = anchorEl.offsetTop - window.scrollY;
    const distance = Math.abs(shift);
    // Clamp duration to prevent scrolling too fast or slow
    const duration = clamp(300, distance, 1200) / 1000;

    document.body.classList.add('is-untouchable');
    // TODO: Consider replacing offsetY with `preventHeaderReveal` event dispatch
    // stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    gsap.to(window, {
      duration,
      ease: 'power2.inOut',
      scrollTo: {
        y: anchorEl,
        offsetY: shift < 0 ? header.offsetHeight : 0,
      },
      onComplete: () => document.body.classList.remove('is-untouchable'),
    });
  });
  anchor.dataset.initialized = true;
};
document
  .querySelectorAll(`a[href^="#"], a[href^="${window.location.pathname}#"]`)
  .forEach(initAnchor);

// Mobile device detection. Use only if absolutely needed to perform a non-vital modification of output or logic.
// This function cannot be relied on to be comprehensive.
const isMobileDevice = () =>
  /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(navigator.userAgent) ||
  /\b(Android|Windows Phone|iPad|iPod)\b/i.test(navigator.userAgent);

// Select element enhancement
// TODO: TEST VANILLA SELECT STYLES AND ENSURE THEY MATCH FANCY SELECT STYLES (all variants)
const fancifySelect = select => {
  const options = {};
  const placeholder = select.dataset.placeholder;
  const searchable = select.hasAttribute('data-searchable');

  if (placeholder) options.placeholder = placeholder;
  if (searchable) options.searchable = true;

  options.simplified = select.dataset.simplified !== undefined;

  if (isMobileDevice()) {
    const target = select.querySelector('select') || select;
    target.classList.add('fancy-select');
    target.classList.toggle('fancy-select--simplified', options.simplified);
    return false;
  }

  return Select.bind(select, options);
};

// TODO: Consider removing and converting all to use web component
// const selectElements = document.querySelectorAll('.select-field .select');
// selectElements.forEach(fancifySelect);

class FancySelect extends HTMLElement {
  constructor() {
    super();

    this.element = this.querySelector('select');
    this.handleChange = this.onValueChange.bind(this);
  }

  connectedCallback() {
    this.select = fancifySelect(this);
    this.element.addEventListener('change', this.handleChange);
  }

  onValueChange(event) {
    const sourceVal = event.target.value;
    if (sourceVal === this.select.selectedOptions[0]?.data.value) return;

    const selectedOption = this.getOptionbyValue(sourceVal)
    this.select.setValue(sourceVal)
  }

  get options() {
    return this.select.options.map(option => option.element)
  }

  getOptionbyValue(value) {
    return this.select.options.find(option => option.data.value === value)
  }

  disconnectedCallback() {
    if (this.select && 'destroy' in this.select) {
      this.select.destroy();
    }
    this.element.removeEventListener('change', this.handleChange);
  }
}
customElements.define('fancy-select', FancySelect);

// Menu active state fix
// TODO: Run on URL update? (facets)
const updateMenuActiveState = (
  linkClass = 'mega-menu__link',
  activeClass = `${linkClass}--active`
) => {
  const toggleLinkActiveState = (link, active = true) => {
    if (active) {
      link.setAttribute('aria-current', 'page');
    } else {
      link.removeAttribute('aria-current');
    }

    link.classList.toggle(activeClass, active);
  };

  const typeFilterKey = 'filter.p.m.filters.type';
  const urlParams = new URLSearchParams(location.search);
  const activeTypeFilters = urlParams.getAll(typeFilterKey);

  if (activeTypeFilters.length !== 1) return;

  const activeTypeFilter = activeTypeFilters[0];
  const menuLinks = Array.from(document.querySelectorAll(`.${linkClass}`));

  const targetLink = menuLinks.find(link =>
    link.search.includes(`${typeFilterKey}=${activeTypeFilter}`)
  );

  if (!targetLink) return;

  targetLink
    .closest('ul')
    .querySelectorAll(`.${linkClass}`)
    .forEach(link => toggleLinkActiveState(link, false));

  toggleLinkActiveState(targetLink, true);
};

if (location.pathname.startsWith('/collections/') && !!location.search) {
  updateMenuActiveState('mega-menu__link');
  updateMenuActiveState('menu-drawer__menu-link', 'is-active');
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container, { inputSelection = true } = {}) {
  if (!container) return;

  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = event => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus({ preventScroll: true });

  if (
    inputSelection &&
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', event => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', event => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

const viewportSizes = {
  ['mobile']: [null, 749],
  ['tablet']: [750, 989],
  ['tablet-large']: [990, 1199],
  ['desktop']: [1200, 1439],
  ['desktop-large']: [1440, null],
};
function breakpointQuery(breakpoint, type = 'min') {
  if (!viewportSizes[breakpoint]) {
    console.error(`Invalid breakpoint: ${breakpoint}`);
    return false;
  }

  if (!['min', 'max'].includes(type)) {
    console.error(`Invalid query type: ${type}`);
    return false;
  }

  const [min, max] = viewportSizes[breakpoint];
  let target = type === 'min' ? min : max;

  if (!target) {
    console.error(
      `Failed to create ${type}-width query: Breakpoint "${breakpoint}" has no ${type}-width`
    );
    return false;
  }

  return `(${type}-width: ${target}px)`;
}

const mediaQueryMap = {
  ['mobile']: '(max-width: 749px)',
  ['tablet']: '(max-width: 989px)',
  ['tablet-up']: '(min-width: 750px)',
  ['desktop']: '(min-width: 990px)',
};
function mediaQueryString(target) {
  return mediaQueryMap[target] ?? false;
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach(video => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    );
  });
  document.querySelectorAll('.js-vimeo').forEach(video => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach(video => video.pause());
  document.querySelectorAll('product-model').forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus({ preventScroll: true });
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(button =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  function setSelected(index, option = selector.options[index]) {
    selector.selectedIndex = index;
    option.setAttribute('selected', 'selected');
    return index;
  }

  if (!value) return setSelected(0);

  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      return setSelected(i, option);
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.countrySelect = this.countryEl.closest('fancy-select')?.select;
  this.provinceEl = document.getElementById(province_domid);
  this.provinceSelect = this.provinceEl.closest('fancy-select')?.select;
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countrySelect?.update();
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
      this.provinceSelect?.update();
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];

        if (i === 0) {
          opt.setAttribute('selected', 'selected');
        }

        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }

    this.provinceSelect?.update();
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

// TODO: Rework to ensure modal overlay is used and has fade animation
// TODO: Look at reworking with GSAP (see ModalDialog)
class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelector('[data-close]')?.addEventListener('click', this.closeMenuDrawer.bind(this))
    this.querySelectorAll('button:not(.field__button):not([data-close]):not(.localization-selector)').forEach(button =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        this.updateViewportHeight();
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  updateViewportHeight() {
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-clip-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    this.querySelector('summary').setAttribute('aria-expanded', false);
    document.body.classList.remove(`overflow-clip-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = time => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = this.header || document.querySelector('.section--header');
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom')
        ? 1
        : 0;
    this.onResizeHandler = debounce(this.onResize.bind(this), RESIZE_DEBOUNCE_TIMER);
    window.addEventListener('resize', this.onResizeHandler);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResizeHandler);
  }

  openMenuDrawer(summaryElement) {
    this.updateHeaderBottomPosition();
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);

    const closeButton = this.mainDetailsToggle.querySelector(".menu-drawer__close");
    document.body.classList.add(`overflow-clip-${this.dataset.breakpoint}`);
    setTimeout(() => {
      trapFocus(this.mainDetailsToggle, closeButton);
    }, 250);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    document.body.classList.remove(`overflow-clip-${this.dataset.breakpoint}`);
  }

  updateHeaderBottomPosition() {
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
  }

  onResize() {
    this.updateViewportHeight();
    this.updateHeaderBottomPosition();
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.type = 'dialog';
    this.overlay = this.getOverlay();
    this.zoomControls = this.querySelectorAll('zoom-controls, slider-zoom-controls');
    this.handleHide = this.hide.bind(this);
    this.handleKeyUp = this.onKeyUp.bind(this);
    this.handleClick = this.onClick.bind(this);
    this.handlePointerUp = this.onPointerUp.bind(this);
    this.handleTimelineStart = this.onStateChange.bind(this, true);
    this.handleTimelineReverseComplete = this.onStateChange.bind(this, false);
  }

  connectedCallback() {
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.handleHide);
    this.addEventListener('keyup', this.handleKeyUp);

    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', this.handlePointerUp);
    } else {
      this.addEventListener('click', this.handleClick);
    }

    if (this.moved) {
      this.buildTimeline();
    } else {
      // Remove duplicates in theme editor
      if (Shopify.designMode && this.id) {
        const duplicateModals = Array.from(
          document.querySelectorAll(`${this.tagName}#${this.id}`)
        ).filter(modal => modal !== this);

        duplicateModals.forEach(duplicate => duplicate.remove());
      }

      this.moved = true;
      document.body.appendChild(this);
    }
  }

  disconnectedCallback() {
    this.timeline?.kill();
    this.querySelector('[id^="ModalClose-"]').removeEventListener('click', this.handleHide);
    this.removeEventListener('keyup', this.handleKeyUp);

    if (this.classList.contains('media-modal')) {
      this.removeEventListener('pointerup', this.handlePointerUp);
    } else {
      this.removeEventListener('click', this.handleClick);
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() === 'ESCAPE') this.hide();
  }

  onClick(event) {
    if (event.target === this) this.hide();
  }

  onPointerUp(event) {
    if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) {
      this.hide();
    }
  }

  buildTimeline() {
    if (this.timeline) this.timeline.kill();

    this.timeline = gsap
      .timeline({
        paused: true,
        onStart: this.handleTimelineStart,
        onReverseComplete: this.handleTimelineReverseComplete,
      })
      .from(this.firstElementChild, {
        scale: 0.7,
        autoAlpha: 0,
        duration: 0.2,
        ease: 'power1.inOut',
      });

    if (this.isOpen()) {
      this.timeline.progress(1);
    }
  }

  onStateChange(open = true) {
    this.updateAttributes(open, true);

    publish(PUB_SUB_EVENTS[open ? 'modal-show' : 'modal-hide'], {
      data: {
        trigger: this.openedBy,
        modal: this,
      },
    });
  }

  updateAttributes(open = true, stateChange = false) {
    document.body.classList.toggle('overflow-clip', open);
    document.body.classList.toggle('has-open-modal', open);

    if (this.overlay) {
      document.body.classList.toggle(`has-open-${this.type}`, open);
    }

    this.toggleAttribute('open', open);

    if (stateChange) {
      if (open) {
        setTimeout(() => {
          trapFocus(this, this.querySelector('[role="dialog"]'));
        }, 100);
      } else {
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
      }
    }
  }

  getOverlay() {
    const overlay = document.querySelector('[data-modal-overlay]');

    if (overlay) return overlay;

    const overlayElement = document.createElement('div');
    overlayElement.classList.add('modal-overlay', 'modal-overlay--primary');
    overlayElement.dataset.modalOverlay = true;
    document.body.appendChild(overlayElement);

    return overlayElement;
  }

  isOpen() {
    return this.hasAttribute('open');
  }

  animate(open = true) {
    this.zoomControls.forEach(zoom => zoom.reset());

    if (open) {
      return this.timeline?.play() ?? Promise.resolve();
    } else {
      return this.timeline?.reverse() ?? Promise.resolve();
    }
  }

  show(opener) {
    this.openedBy = opener;

    this.overlay?.addEventListener('click', this.handleHide);

    const popup = this.querySelector('.template-popup');
    if (popup) popup.loadContent();

    window.pauseAllMedia();
    
    this.animate(true).then(() => {
      this.querySelector(".product-popup-modal__toggle")?.focus();
    });
  }

  hide() {
    this.overlay?.removeEventListener('click', this.handleHide);

    document.body.classList.remove(`has-open-${this.type}`);

    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    this.animate(false);
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalDrawer extends ModalDialog {
  constructor() {
    super();
  }

  buildTimeline() {
    if (this.timeline) this.timeline.kill();

    this.timeline = gsap
      .timeline({
        paused: true,
        onStart: this.handleTimelineStart,
        onReverseComplete: this.handleTimelineReverseComplete,
      })
      .from(this.firstElementChild, {
        xPercent: 100,
        duration: 0.5,
        ease: 'power2.inOut',
      });

    if (this.isOpen()) {
      this.timeline.progress(1);
    }
  }
}
customElements.define('modal-drawer', ModalDrawer);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');

    this.handleOpen = this.open.bind(this);
  }

  connectedCallback() {
    this.button?.addEventListener('click', this.handleOpen);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleOpen);
  }

  open() {
    const modal = document.querySelector(this.getAttribute('data-modal'));

    if (!modal) {
      console.error('modal not found', this.getAttribute('data-modal'));
      return;
    }

    modal.show(this.button);
  }
}
customElements.define('modal-opener', ModalOpener);

class AppointmentOpener extends ModalOpener {
  constructor() {
    super();

    this.form = document.querySelector('#AppointmentForm');
    this.formController = this.form.closest('appointment-form');
    this.list = this.dataset.listId;
    this.location = this.dataset.location;
  }

  open() {
    super.open();
    this.formController.setLocation(this.location, this.list);
  }
}
customElements.define('appointment-opener', AppointmentOpener);

class InquiryOpener extends ModalOpener {
  constructor() {
    super();

    this.list = this.dataset.listId;
    this.identifier = this.dataset.showIdentifier;
    this.input = document.querySelector('[data-list-id-input]');
    this.identifierInput = document.querySelector('[data-show-identifier-input]');
    this.klaviyoInput = document.querySelector('[data-klaviyo-input]');
    this.klaviyoDateInput = document.querySelector('[data-klaviyo-date-input]');
    this.klaviyoBodyInput = document.querySelector('[data-klaviyo-body-input]');
    this.form = document.querySelector('#InquiryForm');
    this.listClass = 'klaviyo_gdpr_embed_' + this.list;
    this.formMessage = document.querySelectorAll(
      '.klaviyo_messages .success_message, .klaviyo_messages .error_message'
    );
    this.successMessage = document.querySelector('.klaviyo_messages .success_message');
    this.errorMessage = document.querySelector('.klaviyo_messages .error_message');
  }

  open() {
    super.open();
    this.input.value = this.list;
    this.form.classList.add(this.listClass);
    this.klaviyoInput.value =
      '$consent,$first_name,$last_name,email,$phone_number,' +
      this.identifier +
      '_date,' +
      this.identifier +
      '_body,' +
      this.identifier;
    this.klaviyoDateInput.name = this.identifier + '_date';
    this.klaviyoBodyInput.name = this.identifier + '_body';
    this.identifierInput.name = this.identifier;

    this.formMessage?.forEach(message => message.classList.add('form__message'));
    this.successMessage.setAttribute('role', 'status');
    this.errorMessage.setAttribute('role', 'alert');
  }
}
customElements.define('inquiry-opener', InquiryOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));

    // if (this.hasAttribute('preload')) {
    //   window.addEventListener('load', this.loadContent.bind(this, false, false));
    // }
  }

  loadContent(focus = true, play = true) {
    if (play) {
      window.pauseAllMedia();
    }

    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));

      if (this.hasAttribute('data-flip-id')) {
        this.querySelector('video, model-viewer, iframe').setAttribute(
          'data-flip-id',
          this.dataset.flipId
        );
        this.removeAttribute('data-flip-id');
      }

      if (focus) this.deferredElement.focus();
      if (
        this.deferredElement.nodeName == 'VIDEO' &&
        this.deferredElement.getAttribute('autoplay') &&
        play
      ) {
        // force autoplay for safari
        this.deferredElement.play();
      }
    } else if (this.deferredElement.nodeName == 'VIDEO' && play) {
      this.deferredElement.play();
    }

    this.dispatchEvent(new CustomEvent('loadContent', {
      detail: {
        media: this.deferredElement,
      },
    }));
  }
}

customElements.define('deferred-media', DeferredMedia);

class GridLayout extends HTMLElement {
  constructor() {
    super();

    this.columnCount = {
      min: parseInt(this.getAttribute('columns-min'), 10),
      max: parseInt(this.getAttribute('columns-max'), 10),
    };
    this.columnMinWidth = this.getAttribute('column-min-width');

    this.build();

    this.gridStyles = getComputedStyle(this.grid);
    this.mm = window.matchMedia('(max-width: 989px)');

    this.debouncedUpdateGrid = debounce(this.updateGrid.bind(this), RESIZE_DEBOUNCE_TIMER);
  }

  build() {
    this.setAttribute('class', 'page-width');
    this.grid = document.createElement('ul');
    this.grid.setAttribute('class', 'grid product-grid');
    this.grid.dataset.columnsMobile = this.columnCount.min;
    this.grid.dataset.columns = this.columnCount.max;

    this.appendChild(this.grid);

    for (let i = 1; i <= this.columnCount.max; i++) {
      const gridItem = document.createElement('li');
      this.grid.appendChild(gridItem);
    }
  }

  connectedCallback() {
    window.addEventListener('resize', this.debouncedUpdateGrid);

    if (this.mm.matches) {
      window.addEventListener('load', this.debouncedUpdateGrid);
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.debouncedUpdateGrid);
    window.removeEventListener('load', this.debouncedUpdateGrid);
  }

  updateGrid() {
    if (this.mm.matches) {
      const contentWidth = parseFloat(this.gridStyles.getPropertyValue('width'));
      const gridSpacing = parseFloat(this.gridStyles.getPropertyValue('column-gap'));
      const columnRange = range(this.columnCount.min, this.columnCount.max).reverse();

      for (const count of columnRange) {
        const spacing = (count - 1) * gridSpacing;
        const width = (contentWidth - spacing) / count;

        if (width < this.columnMinWidth && count !== columnRange[columnRange.length - 1]) continue;

        document.documentElement.style.setProperty('--product-grid-columns', count);
        break;
      }
    } else if (document.documentElement.style.getPropertyValue('--product-grid-columns')) {
      this.resetGrid();
    }

    this.dispatchEvent(new CustomEvent('grid-update'));
  }

  resetGrid() {
    document.documentElement.style.removeProperty('--product-grid-columns');
  }
}

customElements.define('grid-layout', GridLayout);

// TODO: Add "loop" attribute and implement?
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.enableSliderLooping = false;
    this.sliderControlWrapper = this.querySelector('.slider__control-wrapper');

    if (!this.sliderControlWrapper && this.hasAttribute('data-section-pagination')) {
      this.sliderControlWrapper = this.closest('.section').querySelector('.slider__control-wrapper');
    }

    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButtons = this.getButtonElements('previous');
    this.nextButtons = this.getButtonElements('next');
    this.transformScroll = this.hasAttribute('transform-scroll');
    this.connectedId = this.dataset.connectedSlider;
    this.connectedSliders = Array.from(
      document.querySelectorAll(`[data-connected-slider="${this.connectedId}"]`)
    ).filter(slider => slider !== this);
    this.thumbnailSlider = this.dataset.thumbnailSlider
      ? null
      : document.querySelector(`[data-thumbnail-slider="${this.connectedId}"]`);
    this.getItems();
    this.getControlLinks();
    this.initialized = false;
    this.locked = false;
    this.navigationQueue = [];

    this.throttledLock = throttle(this.lockPosition.bind(this), 1000);
    this.debouncedResize = debounce(() => this.initPages(), RESIZE_DEBOUNCE_TIMER);
    this.handleResize = this.onResize.bind(this);
    this.debouncedConnectedSlideChange = debounce(
      this.onConnectedSlideChange.bind(this),
      SLIDE_CHANGE_DEBOUNCE_TIMER
    );
    this.handleUpdate = this.update.bind(this);
    this.handleOrientationChange = this.changeOrientation.bind(this);
    this.handleButtonClick = this.onButtonClick.bind(this);
    this.handleNavigationQueue = this.runQueuedNavigation.bind(this);
    this.handleScrollTransformation = this.onScrollTransformation.bind(this);
    this.mousePosition = { x: 0, y: 0 };
    this.handleMouseMove = debounce(e => {
      const { clientX: x, clientY: y } = e;
      this.mousePosition = { x, y };
      this.scrollOverride = false;
    }, 100);

    this.disableSnap = throttle(() => {
      this.slider.style.scrollBehavior = 'initial';
      this.slider.style.scrollSnapType = 'none';
    }, 300);
    this.revertSnap = debounce(() => {
      this.goToSlide(this.currentPage - 1, {
        onComplete: () => {
          this.slider.style.scrollBehavior = '';
          this.slider.style.scrollSnapType = '';
        },
      });
    }, 100);
  }

  connectedCallback() {
    if (!this.slider) return;

    this.initOrientation();

    if (this.constructor.name !== 'CardSlider') {
      this.initPages();

      this.initialized = true;
      this.dispatchEvent(
        new CustomEvent('sliderInitialized', {
          detail: {
            currentPage: this.currentPage,
            currentElements: this.currentElements,
            currentElement: this.currentElement,
          },
        })
      );
    }

    this.resizeObserver = new ResizeObserver(this.handleResize);
    this.resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.handleUpdate);
    this.prevButtons.forEach(button => button.addEventListener('click', this.handleButtonClick));
    this.nextButtons.forEach(button => button.addEventListener('click', this.handleButtonClick));
    this.connectControlLinks();

    this.connectedSliders.forEach(slider =>
      slider.addEventListener('slideChanged', this.debouncedConnectedSlideChange)
    );

    if (!this.isVertical && this.transformScroll) {
      this.intersectionObserver = new IntersectionObserver(this.observeScroll.bind(this), {
        threshold: [0, 1],
      });
      this.intersectionObserver.observe(this.slider);
    }

    window.addEventListener('mousemove', this.handleMouseMove);
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this.slider.removeEventListener('scroll', this.handleUpdate);
    this.prevButtons.forEach(button => button.removeEventListener('click', this.handleButtonClick));
    this.nextButtons.forEach(button => button.removeEventListener('click', this.handleButtonClick));
    this.orientationMQL?.removeEventListener('change', this.handleOrientationChange);
    this.connectControlLinks(false);

    this.connectedSliders.forEach(slider =>
      slider.removeEventListener('slideChanged', this.debouncedConnectedSlideChange)
    );

    if (!this.isVertical && this.transformScroll) {
      this.intersectionObserver?.disconnect();
      this.slider.removeEventListener('wheel', this.handleScrollTransformation);
    }

    window.removeEventListener('mousemove', this.handleMouseMove);
  }

  get stepSize() {
    this._stepSize ??= this.getAttribute('step-size') ?? 1;
    return this._stepSize === 'visible' ? this.slidesPerPage : this._stepSize;
  }

  observeScroll(entries, observer) {
    for (const entry of entries) {
      if (entry.intersectionRatio === 1) {
        window.addEventListener('wheel', this.handleScrollTransformation, {
          capture: true,
          passive: false,
        });

        const { x, y } = this.mousePosition;

        const cursorElement = document.elementFromPoint(x, y);
        if (cursorElement?.closest('.slider') === this.slider) {
          this.scrollOverride = true;
        } else {
          this.scrollOverride = false;
        }
      } else if (entry.intersectionRatio < 1) {
        window.removeEventListener('wheel', this.handleScrollTransformation);
        this.scrollOverride = false;
      }
    }
  }

  getButtonElements(name) {
    let buttons = this.querySelectorAll(`button[name="${name}"]`);

    if (!buttons.length)
      buttons = document.querySelectorAll(
        `button[aria-controls="${this.slider.id}"][name="${name}"]`
      );

    return buttons;
  }

  connectControlLinks(connect = true) {
    this.sliderControlLinksArray?.forEach(link =>
      connect
        ? link.addEventListener('click', this.linkToSlide.bind(this))
        : link.removeEventListener('click', this.linkToSlide.bind(this))
    );
  }

  initPages() {
    this.releaseLock();

    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      element => element[this.measurement.size] > 0
    );
    if (this.sliderItemsToShow.length > 0) this.currentPage ??= 1;
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1][this.measurement.offset] -
      this.sliderItemsToShow[0][this.measurement.offset];
    this.sliderGap = this.sliderItemOffset - this.sliderItemsToShow[1].clientWidth;
    this.slidesPerPage = Math.max(
      Math.floor(
        (this.slider[this.measurement.size] - this.sliderItemsToShow[0][this.measurement.offset]) /
          this.sliderItemOffset
      ),
      1
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  getItems() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.sliderFirstItemNode = this.slider.querySelector('.slider__slide');
  }

  // TODO: Clean this up
  getControlLinks(update = false) {
    if (!this.sliderControlWrapper) return;

    if (update) {
      const controlLinkSource = this.sliderControlWrapper
        .querySelector('.slider-counter__link')
        ?.cloneNode(true);

      if (!controlLinkSource) {
        console.error(
          'Could not find slider control link source. Add a single control link to dynamic sliders to allow for initialization'
        );
        return;
      }

      this.connectControlLinks(false);
      this.sliderControlWrapper.innerHTML = '';
      // TODO: Consider using sliderItemsToShow (would need to have standard update method for it regardless of dynamic sourcing)
      for (let i = 0; i < this.sliderItems.length; i++) {
        this.sliderControlWrapper.appendChild(controlLinkSource.cloneNode(true));
      }
    }

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper?.querySelectorAll('.slider-counter__link') ?? []
    );

    if (update) {
      this.connectControlLinks();
    }
  }

  resetPages() {
    this.getItems();

    this.getControlLinks(true);
    this.initPages();
  }

  initOrientation() {
    this.verticalTarget = this.getAttribute('vertical') ?? false;

    switch (this.verticalTarget) {
      case 'true':
        this.isVertical = true;
        break;
      case false:
        this.isVertical = false;
        break;
      default:
        const queryString = mediaQueryString(this.verticalTarget);

        if (!queryString) {
          this.isVertical = false;
          break;
        }

        this.orientationMQL = window.matchMedia(queryString);
        this.orientationMQL.addEventListener('change', this.handleOrientationChange);
        this.isVertical = this.orientationMQL.matches;
        break;
    }

    this.updateOrientation();
  }

  // TODO: Clean up orientation handling & language
  changeOrientation(e) {
    this.isVertical = e.matches;
    this.updateOrientation();
  }

  updateOrientation() {
    this.slider.classList.toggle('is-vertical', this.isVertical);
    this.measurement = {
      scroll: this.isVertical ? 'scrollTop' : 'scrollLeft',
      offset: this.isVertical ? 'offsetTop' : 'offsetLeft',
      size: this.isVertical ? 'clientHeight' : 'clientWidth',
    };
  }

  updatePagination() {
    this.sliderControlLinksArray.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlLinksArray[this.currentPage - 1]?.classList.add(
      'slider-counter__link--active'
    );
    this.sliderControlLinksArray[this.currentPage - 1]?.setAttribute('aria-current', true);
  }

  update() {
    if (!this.slider || this.locked) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider[this.measurement.scroll] / this.sliderItemOffset) + 1;
    this.currentElements = this.sliderItemsToShow.slice(
      this.currentPage - 1,
      this.currentPage - 1 + this.slidesPerPage
    );
    this.currentElement = this.sliderItemsToShow[this.currentPage - 1];

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElements: this.currentElements,
            currentElement: this.currentElement,
          },
        })
      );
    }

    if (this.sliderControlLinksArray) this.updatePagination();

    if (this.enableSliderLooping) return;

    if (this.prevButtons.length) {
      if (
        this.isSlideVisible(this.sliderItemsToShow[0]) &&
        this.slider[this.measurement.scroll] === 0
      ) {
        this.prevButtons.forEach(button => button.setAttribute('disabled', 'disabled'));
      } else {
        this.prevButtons.forEach(button => button.removeAttribute('disabled'));
      }
    }

    if (this.nextButtons.length) {
      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButtons.forEach(button => button.setAttribute('disabled', 'disabled'));
      } else {
        this.nextButtons.forEach(button => button.removeAttribute('disabled'));
      }
    }
  }

  onConnectedSlideChange(e) {
    if (this.isNavigating || e.srcElement.isNavigating || e.srcElement.isSlave) return;

    this.isSlave = true;
    this.goToSlide(e.detail.currentPage - 1, {
      onComplete: () => setTimeout(() => (this.isSlave = false), SLIDE_CHANGE_DEBOUNCE_TIMER),
    });
  }

  onResize(entries) {
    this.throttledLock();
    this.debouncedResize();
  }

  onScrollTransformation(event) {
    if (event.target.closest('.slider') !== this.slider && !this.scrollOverride) return;

    const distance = event.deltaX + event.deltaY;
    const scrollDirection = distance > 0 ? 'down' : 'up';
    if (scrollDirection !== this.scrollDirection) {
      this.transformationPaused = false;
    }
    this.scrollDirection = scrollDirection;
    if (this.transformationPaused || event.shiftKey) return;

    const minScroll = 0;
    const maxScroll = this.slider.scrollWidth - this.slider.offsetWidth;
    if (
      (this.slider.scrollLeft >= maxScroll && distance > 0) ||
      (this.slider.scrollLeft <= minScroll && distance < 0)
    ) {
      this.transformationPaused = true;
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (distance > -1 && distance < 1) {
      return;
    }

    this.disableSnap();

    this.slider.scrollLeft += distance;

    this.revertSnap();
  }

  lockPosition() {
    this.locked = true;
  }

  releaseLock() {
    this.locked = false;
  }

  lockAll() {
    this.lockPosition();
    this.connectedSliders.forEach(slider => slider.lockPosition());
  }

  releaseAll() {
    this.releaseLock();
    this.connectedSliders.forEach(slider => slider.releaseLock());
  }

  isSlideVisible(element, offset = 0) {
    if (!element || element[this.measurement.size] <= 0) return false;

    const lastVisibleSlide =
      this.slider[this.measurement.size] + this.slider[this.measurement.scroll] - offset;
    return (
      element[this.measurement.offset] + element[this.measurement.size] <= lastVisibleSlide &&
      element[this.measurement.offset] >= this.slider[this.measurement.scroll]
    );
  }

  runQueuedNavigation() {
    if (!this.navigationQueue.length) return;

    this.navigationQueue.shift()();
  }

  onButtonClick(event) {
    event.preventDefault();

    const button = event.target.closest('button');
    const step = button.dataset.step || this.stepSize;

    this.step(button.name, step);
  }

  step(direction, step = 1) {
    if (this.isNavigating) {
      console.debug('Slider: Button clicked while navigating, enqueueing navigation event');
      this.navigationQueue.push(this.step.bind(this, direction, step));
      return;
    }

    direction =
      direction === 'prev' || direction === 'previous' ? -1 : direction === 'next' ? 1 : direction;
    step = step * direction;

    if (this.currentPage + step > this.totalPages || this.currentPage + step < 1) return;

    const targetSlide = this.currentPage + step - 1;

    this.isNavigating = true;
    this.goToSlide(targetSlide, {
      onComplete: () => {
        const timeout = this.navigationQueue.length > 0 ? 100 : SLIDE_CHANGE_DEBOUNCE_TIMER;
        setTimeout(() => {
          this.isNavigating = false;
          this.runQueuedNavigation();
        }, timeout);
      },
    });

    this.dispatchEvent(
      new CustomEvent('navigate', {
        detail: {
          type: 'navigation',
          currentPage: this.currentPage,
          destinationPage: this.currentPage + step,
          direction,
          step,
          currentElement: this.sliderItemsToShow[targetSlide],
        },
      })
    );

    this.thumbnailSlider?.setActiveThumbnail(targetSlide);
    this.connectedSliders?.forEach(slider => {
      slider.isSlave = true;
      slider.goToSlide(targetSlide, {
        onComplete: () => setTimeout(() => (slider.isSlave = false), SLIDE_CHANGE_DEBOUNCE_TIMER),
      });

      slider.dispatchEvent(
        new CustomEvent('navigate', {
          detail: {
            type: 'navigation',
            currentPage: slider.currentPage,
            destinationPage: slider.currentPage + step,
            direction,
            step,
            currentElement: slider.sliderItemsToShow[targetSlide],
          },
        })
      );
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const index = this.sliderControlLinksArray.indexOf(event.currentTarget);

    this.isNavigating = true;
    this.goToSlide(index, {
      // TODO: Make this default onComplete?
      onComplete: () => {
        setTimeout(() => {
          this.isNavigating = false;
        }, SLIDE_CHANGE_DEBOUNCE_TIMER);
      },
    });

    this.dispatchEvent(
      new CustomEvent('navigate', {
        detail: {
          type: 'pagination',
          currentPage: this.currentPage,
          destinationPage: index + 1,
          currentElement: this.sliderItemsToShow[index],
        },
      })
    );

    // TODO: Test
    this.connectedSliders?.forEach(slider => {
      slider.isSlave = true;
      slider.goToSlide(index, {
        onComplete: () => setTimeout(() => (slider.isSlave = false), SLIDE_CHANGE_DEBOUNCE_TIMER),
      });

      slider.dispatchEvent(
        new CustomEvent('navigate', {
          detail: {
            type: 'pagination',
            currentPage: slider.currentPage,
            destinationPage: index + 1,
            currentElement: slider.sliderItemsToShow[index],
          },
        })
      );
    });
  }

  // TODO: Add support for passing attributes to define duration args
  // TODO: Integrate connectedSliders with navigation (use isNavigating)!
  goToSlide(target, { jump = false, onComplete = null } = {}) {
    if (typeof target === 'number') target = this.sliderItemsToShow[target];

    if (!target) {
      console.debug('Slider: Navigation failed, invalid slide target provided', this, target);
      return;
    }

    const destination =
      target[this.measurement.offset] - this.sliderItemsToShow[0][this.measurement.offset];
    const axis = this.isVertical ? 'y' : 'x';
    const distanceMax =
      this.sliderItemsToShow[this.sliderItemsToShow.length - 1][this.measurement.offset];
    const scrollDuration = calculateScrollDuration(
      this.slider[this.measurement.scroll],
      destination,
      { distanceMax }
    );

    gsap.to(this.slider, {
      ease: 'sine.inOut',
      duration: jump ? 0 : scrollDuration,
      scrollTo: { [axis]: destination },
      onComplete,
    });

    if (jump) this.update();
  }
}

customElements.define('slider-component', SliderComponent);

// TODO: Update pagination to show all visible slides as active (figure out click event)
class CardSlider extends SliderComponent {
  constructor() {
    super();
    this.gridLayout = document.querySelector('grid-layout');
    this.onGridUpdate = this.updateGrid.bind(this);
    this.cardProps = {
      hidden: {
        autoAlpha: 0,
        scale: 0.95,
      },
      visible: {
        autoAlpha: 1,
        scale: 1,
      },
    };
  }

  connectedCallback() {
    super.connectedCallback();
    this.gridLayout.addEventListener('grid-update', this.onGridUpdate);
    // TODO: Consider implementing this on standard slider
    this.initObserver();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.gridLayout.removeEventListener('grid-update', this.onGridUpdate);
    this.observer.disconnect();
  }

  static get observedAttributes() {
    return ['aria-hidden'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'aria-hidden') {
      if (!this.isHidden()) {
        this.updateGrid();
      }
    }
  }

  initObserver() {
    this.observer = new MutationObserver((mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
          this.resetPages();
        }
      }
    });

    this.observer.observe(this.slider, {
      childList: true,
    });
  }

  initPages() {
    this.releaseLock();

    if (!this.isActive()) {
      if (this.initialized) this.reset();

      return;
    }

    if (this.isHidden()) return;

    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      element => element.clientWidth > 0
    );

    this.slider.classList.toggle('is-active', this.isActive());
    this.classList.toggle('is-active', this.isActive());

    if (this.sliderItemsToShow.length < 2) return;

    if (!this.initialized) this.init();

    this.update();
  }

  // TODO: Consider implementing orientation support (see SliderComponent)
  updateSliderVars() {
    this.sliderOffset = this.sliderItemsToShow[0].offsetLeft;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.sliderGap = this.sliderItemOffset - this.sliderItemsToShow[1].clientWidth;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderOffset * 2 + this.sliderGap) / this.sliderItemOffset +
        0.1
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
  }

  updateGrid() {
    if (!this.initialized) return;
    this.updateSliderVars();

    if (this.mm.contexts[0].conditions.matches) {
      this.sliderItemsToShow.forEach(slide => {
        this.updateSlideVisibility(slide);
      });

      this.refreshTimelines();
    }
  }

  updatePagination() {
    this.sliderControlLinksArray.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });

    let currentIndex = this.currentPage - 1;
    this.sliderControlLinksArray[currentIndex]?.setAttribute('aria-current', true);

    for (let i = 0; i < this.slidesPerPage; i++) {
      this.sliderControlLinksArray[currentIndex + i]?.classList.add('slider-counter__link--active');
    }
  }

  reset() {
    this.mm.revert();
    this.timelines = [];
    this.initialized = false;
  }

  init() {
    this.initialized = true;
    this.mm = gsap.matchMedia();
    this.updateSliderVars();
    this.createTimelines();

    this.dispatchEvent(
      new CustomEvent('sliderInitialized', {
        detail: {
          currentPage: this.currentPage,
          currentElements: this.currentElements,
          currentElement: this.currentElement,
        },
      })
    );
  }

  isActive() {
    return this.slider.scrollWidth > this.slider.clientWidth;
  }

  isHidden() {
    return this.getAttribute('aria-hidden') === 'true';
  }

  updateSlideVisibility(slide, card) {
    card ??= slide.querySelector('.card-wrapper');
    const isHidden = !this.isSlideVisible(slide);

    card.classList.toggle('is-hidden', isHidden);

    if (isHidden) {
      gsap.set(card, { ...this.cardProps.hidden });
    } else {
      gsap.set(card, { ...this.cardProps.visible });
    }
  }

  createTimelines() {
    // TODO: Replace with context and apply at all breakpoints! (mobile has extra item peeking)
    this.mm.add('(min-width: 750px)', () => {
      this.timelines = [];

      this.sliderItemsToShow.forEach(slide => {
        const card = slide.querySelector('.card-wrapper');

        this.updateSlideVisibility(slide, card);

        this.timelines.push(
          gsap
            .timeline({
              scrollTrigger: {
                trigger: slide,
                scroller: this.slider,
                horizontal: true,
                scrub: true,
                start: () => `left right-=${this.sliderOffset}px`,
                end: () => `right left+=${this.sliderOffset}px`,
              },
            })
            .to(card, {
              ...this.cardProps.visible,
              ease: 'power1.in',
              onComplete: () => card.classList.remove('is-hidden'),
              onReverseComplete: () => card.classList.add('is-hidden'),
            })
            .to(
              card,
              {
                ...this.cardProps.hidden,
                ease: 'power1.out',
                onComplete: () => card.classList.add('is-hidden'),
                onReverseComplete: () => card.classList.remove('is-hidden'),
              },
              '+=2'
            )
        );
      });
    });
  }

  disableTimelines() {
    this.timelines.forEach(timeline => timeline.scrollTrigger?.disable());
  }

  enableTimelines() {
    this.timelines.forEach(timeline => timeline.scrollTrigger?.enable());
  }

  toggleTimelines(enable) {
    if (enable) {
      this.enableTimelines();
    } else {
      this.disableTimelines();
    }
  }

  refreshTimelines() {
    this.timelines.forEach(timeline => {
      timeline.scrollTrigger?.refresh();
    });
  }

  // TODO: Consider implementing orientation support (see SliderComponent)
  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth +
      this.slider.scrollLeft +
      this.sliderGap -
      this.sliderOffset -
      offset;

    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft + this.sliderOffset
    );
  }
}

customElements.define('card-slider', CardSlider);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.enableSliderLooping = !this.hasAttribute('no-loop');
    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
  }

  connectedCallback() {
    super.connectedCallback();

    if (!this.sliderControlWrapper) return;

    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.slider.removeEventListener('scroll', this.setSlideVisibility.bind(this));
  }

  setAutoPlay() {
    console.warn('Autoplay is not yet implemented for this component');
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider[this.measurement.scroll] +
        this.sliderFirstItemNode[this.measurement.size] * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    const direction = this.isVertical ? 'top' : 'left';
    this.slider.scrollTo({
      [direction]: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButtons.forEach(button => button.removeAttribute('disabled'));

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1]?.classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1]?.setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider[this.measurement.scroll] +
          this.slider.querySelector('.slideshow__slide')[this.measurement.size];
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach(button => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach(button => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);

    this.productShippingDate = this.dataset.shippingDate;
    this.productMTO = this.dataset.mto;
    if (this.productMTO === 'true' || this.productMTO === 'false') {
      this.productMTO = this.productMTO === 'true';
    }

    this.updateOptions();
    this.updateMasterId();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();

      /* Need SKu per variant for tracking */
      document.dispatchEvent(new CustomEvent('variant:change', {
        detail: {
          variant: this.currentVariant
        }
      }));

    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), select => select.value);
  }

  updateMasterId() {
    this.previousVariant = { ...this.currentVariant };
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
    this.shippingDate = this.getVariantShippingDates().find(variant => variant.id === this.currentVariant.id)?.shippingDate ?? this.productShippingDate;
    this.mtoMessage = this.getVariantMTO().find(variant => variant.id === this.currentVariant.id)?.madeToOrder ?? this.productMTO;
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach(mediaGallery =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach(productForm => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      variant => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          variant => variant.available && variant[`option${index}`] === previousOptionSelected
        )
        .map(variantOption => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          '[value]',
          input.getAttribute('value')
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then(response => response.text())
      .then(responseText => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            'visibility-hidden',
            skuSource.classList.contains('visibility-hidden')
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            'visibility-hidden',
            inventorySource.innerText === ''
          );

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        // TODO: Wrap in price change conditional
        this.updateAffirm(price.dataset.price);

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            productId: this.dataset.productId,
            variant: this.currentVariant,
            previousVariant: this.previousVariant,
          },
        });
      });
  }

  updateAffirm(price) {
    if (!affirm) {
      console.error('Failed to update Affirm pricing, the object "affirm" does not exist.');
      return;
    }

    const container = document.querySelector(
      `[data-original-section="${this.dataset.section}"], [data-section="${this.dataset.section}"]`
    ).parentElement;

    container.querySelectorAll('[data-affirm]').forEach(affirmPromo => {
      affirmPromo.dataset.amount = price;
    });

    affirm.ui.refresh();
  }

  setPreorderStatus(button) {
    if (this.shippingDate) {
      button.setAttribute('data-shipping-date', this.shippingDate);
    } else {
      button.removeAttribute('data-shipping-date');
    }
  }

  setMTOStatus(button) {
    if (this.mtoMessage) {
      button.setAttribute('data-mto', this.mtoMessage);
    } else {
      button.removeAttribute('data-mto');
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButtons = productForm.querySelectorAll('[name="add"]');
    addButtons.forEach(addButton => {
      this.setPreorderStatus(addButton);
      this.setMTOStatus(addButton);
      const addButtonText = addButton.querySelector('[name="add"] > span');

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');

        if (this.shippingDate) {
          addButtonText.innerHTML = window.variantStrings.preorderWithShippingDate.replace('[shipping_date]', this.shippingDate);
        } else {
          addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (this.mtoMessage) {
          console.log(this.mtoMessage, typeof this.mtoMessage);
          if (this.mtoMessage === true) {
            addButtonText.innerHTML = window.variantStrings.madeToOrderWithoutMessage;
          } else {
            addButtonText.innerHTML = window.variantStrings.madeToOrderWithMessage.replace('[message]', this.mtoMessage);
          }
        }
      }
    });

    if (!modifyClass) return;
  }

  setUnavailable() {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    const addButtons = productForm.querySelectorAll('[name="add"]');
    addButtons.forEach(addButton => {
      const addButtonText = addButton.querySelector('[name="add"] > span');
      addButtonText.textContent = window.variantStrings.unavailable;
    });

    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData ||= JSON.parse(this.querySelector('[data-product-variants][type="application/json"]').textContent);
    return this.variantData;
  }

  getVariantShippingDates() {
    this.variantShippingDates ||= JSON.parse(this.querySelector('[data-variant-shipping-dates][type="application/json"]').textContent);
    return this.variantShippingDates;
  }

  getVariantMTO() {
    this.variantMTO ||= JSON.parse(this.querySelector('[data-mto-messages][type="application/json"]').textContent);
    return this.variantMTO;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map(fieldset => {
      return Array.from(fieldset.querySelectorAll('input')).find(radio => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            reinjectScripts(this);
          }

          if (
            !this.querySelector('slideshow-component') &&
            this.classList.contains('complementary-products')
          ) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class DateField extends HTMLElement {
  constructor() {
    super();

    this.displayInput = this.querySelector('[data-display-input]');
    this.dateInput = this.querySelector('[data-date-input]');
    this.handleFocus = this.onFocus.bind(this);
    this.handleChange = this.onChange.bind(this);
    this.value = null;
  }

  connectedCallback() {
    this.displayInput.addEventListener('focus', this.handleFocus);
    this.displayInput.addEventListener('click', this.handleFocus);
    this.dateInput.addEventListener('change', this.handleChange);
  }

  disconnectedCallback() {
    this.displayInput.removeEventListener('focus', this.handleFocus);
    this.displayInput.removeEventListener('click', this.handleFocus);
    this.dateInput.removeEventListener('change', this.handleChange);
  }

  onFocus() {
    this.dateInput.showPicker();
  }

  onChange() {
    this.value = this.dateInput.value;
    this.displayValue = this.value
      ? new Date(this.value + 'T00:00:00').toLocaleDateString('en-US', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
        })
      : '';

    this.displayInput.value = this.displayValue;
  }
}

customElements.define('date-field', DateField);

Shopify.money_format = '${{amount}}';
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') cents = cents.replace('.', '');

  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*}}/;
  const formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt === 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) return 0;

    const parts = (number = (number / 100).toFixed(precision)).split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', ',');
      break;
    case 'amount_with_period_and_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
  }

  return formatString.replace(placeholderRegex, value);
};

function clearRecentlyViewedProducts() {
  localStorage.removeItem('recentlyViewedProducts');
}

// Auto-update links to open in a new tab
(function () {
  for (const link of document.links) {
    if (link.hostname !== window.location.hostname) {
      link.target = '_blank';
      link.rel = 'noreferrer noopener';
    }
  }
})();
